// extracted by mini-css-extract-plugin
module.exports = {"inviteFormRowWrapper":"styles_inviteFormRowWrapper__2GRTP","fieldWrapper":"styles_fieldWrapper__3pU5f","tagsWrapper":"styles_tagsWrapper__l9JOl","tag":"styles_tag__a4voU"};